/* eslint-disable no-undef */
import Core6Utilities from './Core6Utilities';

export default class Core6ImageManager {
  init(e) {
    this.getImageList(e.detail.current_image);
    this.setOptions(e.detail.row_id, e.detail.component_id);

    const modeSelectors = Core6Utilities.getElementAll('.mode_selector');

    // Select the first image
    Core6ImageManager.selectTab(modeSelectors[0].parentNode);

    const mediaPickerModal = Core6Utilities.getJQueryElement('.mediaPickerModal');

    mediaPickerModal.on('click', '.mode_selector', (evt) => {
      if (!Core6Utilities.hasClass(evt.target, 'delete_selected_image')) {
        Core6ImageManager.selectTab(evt.target.parentNode);
      }
    });

    mediaPickerModal.on('click', '.img_preview', (evt) => {
      if (!Core6Utilities.hasClass(evt.target, 'delete_selected_image')) {
        Core6ImageManager.selectTab(evt.target.parentNode);
      }
    });

    mediaPickerModal.on('click', '.delete_selected_image', (evt) => {
      this.deleteSelectedImage(evt.target);
    });

    mediaPickerModal.on('click', '.edit_selected_image', function () {
      // that.select_tab(evt.target.parentNode);
      Core6ImageManager.changeStateToEditor();

      //console.log($(this).parent().parent().parent());
      const image = $(this).parent().parent().parent()
        .data('image-id');
      Core6Utilities.getJQueryElement('input[name="editing_image_id"]').val(image);
      Core6Utilities.getJQueryElement('#image_edit_box').css('background-image', `url(/large/${image})`);
    });

    mediaPickerModal.on('click', '.upload_image', () => {
      // that.select_tab(evt.target.parentNode);
      Core6ImageManager.changeStateToUploader();
    });

    mediaPickerModal.on('change textInput input', '.editor_control', function () {
      //console.log($(this).val());
      const type = $(this).attr('name');
      //console.log(type);
      switch (type) {
        case 'scale':
          Core6Utilities.getJQueryElement('#image_edit_box').css('background-size', `${$(this).val()}%`);
          break;
        case 'rotate':
          Core6Utilities.getJQueryElement('#image_edit_box').css('transform', `rotate(${$(this).val()}deg)`);
          break;
        default:
          break;
      }
    });

    // Default State
    Core6ImageManager.changeStateToUploader();

    Core6Utilities.getElement('.mediaPickerModal').addEventListener('onImageSelect', (evt) => {
      let selectedSlot = document.querySelector('.img_preview.selected');
      if (selectedSlot !== null && selectedSlot !== undefined) {
        selectedSlot = selectedSlot.parentNode;
        const imagePreview = selectedSlot.querySelector('.img_preview.selected');
        const checkbox = selectedSlot.querySelector('input');
        checkbox.value = evt.detail.image_id;
        checkbox.dataset.value = evt.detail.image_id;
        checkbox.id = `image${evt.detail.image_id}`;
        imagePreview.dataset.imageId = evt.detail.image_id;
        imagePreview.style.backgroundImage = `url('/thumbnails/${evt.detail.image_id}')`;
        imagePreview.querySelector('.image_icons').style.display = 'block';
      }
      this.createNewImageFromTemplate(0);

      this.refreshImageList();
    }, false);

    this.refreshImageList();
  }

  static changeStateToUploader() {
    Core6Utilities.getJQueryElement('.edit_selected_image').parent().css('display', 'block');
    Core6Utilities.getJQueryElement('.upload_image').parent().css('display', 'none');
    Core6Utilities.getJQueryElement('.delete_selected_image').parent().css('display', 'block');
    Core6Utilities.getJQueryElement('#media_editor_panel').css('display', 'none');
    Core6Utilities.getJQueryElement('#media_uploader_panel').css('display', 'block');
  }

  static changeStateToEditor() {
    Core6Utilities.getJQueryElement('.edit_selected_image').parent().css('display', 'none');
    Core6Utilities.getJQueryElement('.upload_image').parent().css('display', 'block');
    Core6Utilities.getJQueryElement('.delete_selected_image').parent().css('display', 'block');
    Core6Utilities.getJQueryElement('#media_editor_panel').css('display', 'block');
    Core6Utilities.getJQueryElement('#media_uploader_panel').css('display', 'none');
  }

  deleteSelectedImage(deleteButton) {
    // Get position in list
    const item = Core6Utilities.findAncestor(deleteButton, 'new_image_placeholder');

    if (item !== null && item !== undefined) {
      // Remove it
      const parent = item.parentNode;
      parent.removeChild(item);

      Core6ImageManager.updateImageMediaButtonValue($(this).data('param'), $(this).data('value'), $(this));

      // Update image list
      this.refreshImageList();

      // Select first item
      const modeSelectors = document.querySelectorAll('.mode_selector');

      // Select the first image
      Core6ImageManager.selectTab(modeSelectors[0].parentNode);
    }
  }

  static updateImageMediaButtonValue(param, value, element) {
    Core6Utilities.getJQueryElement('.core6_selected_image').removeClass('core6_selected_image');
    element.addClass('core6_selected_image');
    //console.log(`Setting Value to: ${value}`);

    const onImageSelectEvent = new CustomEvent('onImageSelect', {
      detail: {
        image_id: value,
      },
    });
    Core6Utilities.getElement('.mediaPickerModal').dispatchEvent(onImageSelectEvent);
  }

  refreshImageList() {
    this.imageList = [];
    const imageSelectors = Core6Utilities.getElementAll('.new_image_placeholder');
    for (let i = 0; i < imageSelectors.length; i += 1) {
      const val = imageSelectors[i].querySelector('input').value;
      if (val !== 0 && val !== '0') {
        this.imageList.push(val);
      }
    }
    this.imageListString = this.imageList.join(';');
    Core6Utilities.getElement('#media_uploader_button').dataset.value = this.imageListString;
    Core6Utilities.getElement('#media_uploader_button').attributes.dataValue = this.imageListString;
  }

  static selectTab(tab) {
    //console.log(tab);
    if (tab.querySelector('input') === undefined || tab.querySelector('input') === null) {
      return;
    }

    Core6ImageManager.hideModeTabs();

    const checkbox = tab.querySelector('input');

    checkbox.checked = 'checked';

    if (checkbox.dataset.value === undefined) {
      // We must be an options menu
      Core6Utilities.getElement(`#${checkbox.value}options`).style.display = 'block';
    } else {
      // We must be an image
      const imagePreview = tab.querySelector(`.img_preview[data-image-id="${checkbox.dataset.value}"]`);

      imagePreview.classList.add('selected');
      if (checkbox.dataset.value === 0 || checkbox.dataset.value === '0') {
        imagePreview.querySelector('.image_icons').style.display = 'none';
      } else {
        imagePreview.querySelector('.image_icons').style.display = 'block';
      }
      Core6Utilities.getElement('#image_selector').style.display = 'block';

      // Deselect the image in the media picker
      const currentSelected = Core6Utilities.getElement('.flex-squares-container .core6_selected_image');
      if (currentSelected !== null && currentSelected !== undefined) {
        currentSelected.classList.remove('core6_selected_image');
      }

      // Select the correct image in the media picker
      if (tab.dataset.value !== 0) {
        const newSelected = Core6Utilities.getElement(`.flex-squares-container .thumbnail[data-value="${checkbox.dataset.value}"]`);
        if (newSelected !== null && newSelected !== undefined) {
          newSelected.classList.add('core6_selected_image');
        }
      }
    }
  }

  static hideModeTabs() {
    Core6ImageManager.deselectImages();
    const modeTabs = Core6Utilities.getElementAll('.mode_tab');
    for (let i = 0; i < modeTabs.length; i += 1) {
      modeTabs[i].style.display = 'none';
    }
  }

  static deselectImages() {
    const images = Core6Utilities.getElementAll('.img_preview');
    for (let i = 0; i < images.length; i += 1) {
      images[i].classList.remove('selected');
      images[i].querySelector('.image_icons').style.display = 'none';
    }
  }

  getImageList(imagesListParam) {
    if (imagesListParam === null || imagesListParam === undefined) {
      // eslint-disable-next-line no-param-reassign
      imagesListParam = '';
    }
    this.imageListString = imagesListParam;
    this.imageList = imagesListParam.split(';');

    Core6Utilities.getElement('#image_selector_list').innerHTML = '';
    for (let i = 0; i < this.imageList.length; i += 1) {
      if (this.imageList[i] !== '' && this.imageList[0] !== 0) {
        this.createNewImageFromTemplate(this.imageList[i]);
      }
    }
    if (!this.imageList.includes('0')) {
      this.createNewImageFromTemplate(0);
    }
  }

  setOptions(rowId, componentId) {
    let mainContainer;
    if (componentId === 0 || componentId === '0' || componentId === undefined) {
      // We're a block!
      //console.log(`block ${rowId}`);
      mainContainer = Core6Utilities.getElement(`.core6-mainrow-container[data-row-id="${rowId}"]:not(.isTemplate)`);
    } else {
      // We're a component
      //console.log(`component ${componentId}`);
      mainContainer = Core6Utilities.getElement(`.core6_component[data-component-id="${componentId}"]`);
    }

    //console.log(mainContainer);

    const optionsSel = mainContainer.querySelector('.feature_image_holder');
    if (optionsSel) {
      const options = optionsSel.dataset;
    } else {
      const options = [];
    }
  }

  createNewImageFromTemplate(imageId) {
    // Don't want more than one empty slot!
    if (imageId === 0 && Core6Utilities.getElementAll('#image_selector_list .mode_selector[value="0"]').length > 0) {
      return;
    }

    const template = document.createElement('div');
    template.innerHTML = Core6Utilities.getElement('#image_list_template').innerHTML;
    template.classList.remove('.new_image_placeholder');
    template.querySelector('.template_image_icons').classList.add('image_icons');
    template.querySelector('.template_image_icons').classList.remove('template_image_icons');
    template.querySelector('.template_img_preview').classList.add('img_preview');
    template.querySelector('.template_img_preview').classList.remove('template_img_preview');
    template.querySelector('.img_preview').style.backgroundImage = `url('/thumbnails/${imageId}')`;
    template.querySelector('.img_preview').dataset.imageId = imageId;
    template.querySelector('.template_mode_selector').classList.add('mode_selector');
    template.querySelector('.template_mode_selector').classList.remove('template_mode_selector');
    template.querySelector('.mode_selector').value = imageId;
    template.querySelector('.mode_selector').dataset.value = imageId;
    template.querySelector('.edit_selected_image').dataset.value = imageId;
    template.querySelector('.delete_selected_image').dataset.value = imageId;
    template.querySelector('.mode_selector').id = `image${imageId}`;

    Core6Utilities.getElement('#image_selector_list').innerHTML = Core6Utilities.getElement('#image_selector_list').innerHTML + template.innerHTML;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/core6/Core6ImageManager.js